import * as React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { ThemeToggle } from '../theme-toggle';
import { Button } from '../ui/button';
import { Menu } from 'lucide-react';
import { LoginButton, UserProfile } from '../auth';
import { appConfig } from '../../config/appConfig';

interface TopbarProps {
  readonly onOpenMobileNav?: () => void;
}

export function Topbar({ onOpenMobileNav }: Readonly<TopbarProps>) {
  const isAuthenticated = useIsAuthenticated();

  // Debug logging to understand auth state
  React.useEffect(() => {
    console.log('[Topbar] enableAuth:', appConfig.enableAuthentication, 'isAuthenticated:', isAuthenticated);
  }, [isAuthenticated]);

  return (
    <header
      className="w-full h-14 border-b flex items-center px-4 gap-3 bg-background/60 backdrop-blur supports-[backdrop-filter]:bg-background/40"
      role="banner"
      aria-label="Application top bar"
    >
      <div className="flex items-center gap-2 md:hidden">
        <Button variant="outline" size="icon" onClick={onOpenMobileNav} aria-label="Open navigation menu">
          <Menu className="w-4 h-4" aria-hidden="true" />
        </Button>
      </div>
      <div className="ml-auto flex items-center gap-2" aria-label="Theme and user controls">
        <ThemeToggle aria-label="Toggle color theme" />
        {appConfig.enableAuthentication && (
          isAuthenticated ? <UserProfile /> : <LoginButton />
        )}
      </div>
    </header>
  );
}
